import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative pt-24 pb-16 px-4 bg-gradient-to-b from-[#F8FAFC] to-white">
      <div className="max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F97316]/10 rounded-full text-[#F97316] font-medium text-sm mb-6">
            <span className="w-2 h-2 bg-[#F97316] rounded-full animate-pulse"></span>
            Limited Spots Available
          </div>
          
          <motion.div 
            className="text-6xl font-bold mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ 
              duration: 0.8,
              delay: 0.2,
            }}
          >
            <h1 className="bg-gradient-to-r from-[#15213A] via-[#1C98ED] to-[#F97316] bg-clip-text text-transparent">
              Join The Cloud
            </h1>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ 
                duration: 0.8,
                delay: 0.4,
              }}
              className="relative mt-2"
            >
              <h1 className="bg-gradient-to-r from-[#F97316] via-[#1C98ED] to-[#15213A] bg-clip-text text-transparent">
                Acceleration Program
              </h1>
              <motion.div 
                className="absolute -bottom-2 left-0 w-full h-1.5 bg-gradient-to-r from-[#F97316] via-[#1C98ED] to-[#15213A] rounded-full"
                initial={{ width: 0, left: '50%' }}
                animate={{ width: '100%', left: 0 }}
                transition={{ duration: 0.8, delay: 0.8 }}
              />
            </motion.div>
          </motion.div>

          <motion.p 
            className="text-xl text-[#15213A] mb-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            Master Azure Cloud Engineering with hands-on projects and real-world skills
            <br />
            <span className="font-medium text-[#1C98ED]">become job-ready in just 6 months</span>
          </motion.p>

          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="mb-6"
          >
            <button 
              onClick={() => {
                const pricingSection = document.querySelector('#pricing-section');
                if (pricingSection) {
                  pricingSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="inline-block bg-[#F97316] hover:bg-[#F97316]/90 text-white font-medium px-10 py-4 rounded-full transition-all duration-300 transform hover:shadow-xl text-lg"
            >
              Enroll Now
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            <svg 
              className="w-8 h-8 mx-auto text-[#1C98ED] animate-bounce" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={3} 
                d="M19 14l-7 7m0 0l-7-7m7 7V3" 
              />
            </svg>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero; 